// extracted by mini-css-extract-plugin
module.exports = {"expressionsAutocomplete":"ExpressionForCompareSelect_expressionsAutocomplete__22TBV"};